module.exports = __webpack_public_path__ + "static/the-four-steps-to-the-epiphany-1d9aa16b31b5e8e4b300479ef866ad82.jpg";